import {Component, OnInit} from '@angular/core';
import {DatasourceService} from "../../services/datasource.service";
import {Item} from "../../models/item.inferface";
import {Observable} from "rxjs";
import {FuseConfigService} from "../../../@fuse/services/config.service";
import {FuseNavigationService} from "../../../@fuse/components/navigation/navigation.service";
import {TenantService} from "../../services/tenant.service";
import {TenantSelectorService} from "../../services/tenant-selector.service";
import { Router } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TenantByNameSuggestService, Tenantstem } from 'app/services/suggest/tenant-by-name.suggest.service';
import { MVLocalStorageService } from 'app/services/mv-local-storage.service';
import { MainPageService, PageContent } from 'app/services/main-page.service';
@Component({
  selector: 'app-tenant-selector-component',
  templateUrl: './tenant-selector.component.html',
  styles: [
    `
      :host {
          display: grid;
      }
    `
  ]
})



export class TenantSelectorComponent implements OnInit {

  public tenants$: Observable<Item[]>;
  public tenantSelector: FormControl;
  tenantForm: FormGroup;
  tenants1: Item[];
  currentTenantsItem: Tenantstem;

  mockData: PageContent[] = [
    {
        "header": "Travel",
        "title": "Primero Usted",
        "tenantId": 1,
        "contentTypeId": 1,
        "body": "Canal de comunicación independiente, seguro, confidencial y anónimo que garantiza protección a los denunciantes ante cualquier medida que pudiera tomar la organización como consecuencia de la denuncia efectuada.",
        "thumbnailFileId": 1,
        "thumbnailFile": {
            "id": 1,
            "name": "file1",
            "fileLength": 1,
            "mimeType": "image/png",
            "url": "../../../assets/images/demo-content/1.Primero Usted.png"//"https://i.imgur.com/eECefMJ.jpg"
        },
        "mediaFileId": 1,
        "mediaFile": {
            "id": 1,
            "name": "file1",
            "fileLength": 1,
            "mimeType": "image/png",
            "url": "../../../assets/images/demo-content/1.Primero Usted.png"
        },
        "orderPosition": 1,
        "active": true
    },
    {
        "header": "Travel2",
        "title": "Fácilmente Accesible",
        "tenantId": 1,
        "contentTypeId": 1,
        "body": "Múltiples canales para el reporte de denuncias: correo electrónico, línea telefónica gratuita, sitio web y casilla de correo postal.",
        "thumbnailFileId": 2,
        "thumbnailFile": {
          "id": 2,
          "name": "file1",
          "fileLength": 1,
          "mimeType": "image/png",
            "url": "../../../assets/images/demo-content/2.Facilmente accesible.png"
        },
        "mediaFileId": 1,
        "mediaFile": {
          "id": 3,
          "name": "file1",
          "fileLength": 1,
          "mimeType": "image/png",
            "url": "../../../assets/images/demo-content/2.Facilmente accesible.png"
        },
        "orderPosition": 2,
        "active": true
    },
    {
        "header": "Travel3",
        "title": "Servicio complementario",
        "tenantId": 1,
        "contentTypeId": 1,
        "body": "Ayudamos a las organizaciones a hacer frente a los principales riesgos financieros y reputacionales asociados con las denuncias recibidas",
        "thumbnailFileId": 3,
        "thumbnailFile": {
          "id": 1,
          "name": "file1",
          "fileLength": 1,
          "mimeType": "image/png",
            "url": "../../../assets/images/demo-content/3. Servicio complementario.png"
        },
        "mediaFileId": 5,
        "mediaFile": {
          "id": 1,
          "name": "file1",
          "fileLength": 1,
          "mimeType": "image/png",
            "url": "../../../assets/images/demo-content/3. Servicio complementario.png"
        },
        "orderPosition": 3,
        "active": true
    },
    {
        "header": "Travel2",
        "title": "24/7/365",
        "tenantId": 1,
        "contentTypeId": 1,
        "body": "Recepción de denuncias a toda hora, todos los días, durante todo el año.",
        "thumbnailFileId": 2,
        "thumbnailFile": {
          "id": 2,
          "name": "file1",
          "fileLength": 1,
          "mimeType": "image/png",
            "url": "../../../assets/images/demo-content/4. 247365.png"
        },
        "mediaFileId": 1,
        "mediaFile": {
          "id": 3,
          "name": "file1",
          "fileLength": 1,
          "mimeType": "image/png",
            "url": "../../../assets/images/demo-content/4. 247365.png"
        },
        "orderPosition": 2,
        "active": true
    },
    {
        "header": "Travel2",
        "title": "Equipo de Profesionales",
        "tenantId": 1,
        "contentTypeId": 1,
        "body": "Denuncias tratadas de forma confidencial y profesional por un equipo independiente de especialistas en investigación de fraudes.",
        "thumbnailFileId": 2,
        "thumbnailFile": {
          "id": 2,
          "name": "file1",
          "fileLength": 1,
          "mimeType": "image/png",
            "url": "../../../assets/images/demo-content/5. Equipo de profesionales.png"
        },
        "mediaFileId": 1,
        "mediaFile": {
          "id": 3,
          "name": "file1",
          "fileLength": 1,
          "mimeType": "image/png",
            "url": "../../../assets/images/demo-content/5. Equipo de profesionales.png"
        },
        "orderPosition": 2,
        "active": true
    },
    {
        "header": "Travel2",
        "title": "Líderes a nivel mundial",
        "tenantId": 1,
        "contentTypeId": 1,
        "body": "Pwc ofrece un equipo global de especialistas en la detección y prevención de fraudes con la capacidad de afrontar un espectro completo de situaciones desde cuestiones locales a desafíos transnacionales.",
        "thumbnailFileId": 2,
        "thumbnailFile": {
          "id": 2,
          "name": "file1",
          "fileLength": 1,
          "mimeType": "image/png",
            "url": "../../../assets/images/demo-content/Contacto.png"
        },
        "mediaFileId": 1,
        "mediaFile": {
          "id": 3,
          "name": "file1",
          "fileLength": 1,
          "mimeType": "image/png",
            "url": "../../../assets/images/demo-content/Contacto.png"
        },
        "orderPosition": 2,
        "active": true
    },
    {
        "header": "Travel2",
        "title": "Gestión de denuncias",
        "tenantId": 1,
        "contentTypeId": 1,
        "body": "Sistema para gestionar el estado y los avances en la investigación de cada una de las denuncias.",
        "thumbnailFileId": 2,
        "thumbnailFile": {
          "id": 2,
          "name": "file1",
          "fileLength": 1,
          "mimeType": "image/png",
            "url": "../../../assets/images/demo-content/Gestion de denuncias.png"
        },
        "mediaFileId": 1,
        "mediaFile": {
          "id": 3,
          "name": "file1",
          "fileLength": 1,
          "mimeType": "image/png",
            "url": "../../../assets/images/demo-content/Gestion de denuncias.png"
        },
        "orderPosition": 2,
        "active": true
    },
    {
        "header": "Travel2",
        "title": "Contacto con denunciantes anónimos",
        "tenantId": 1,
        "contentTypeId": 1,
        "body": "Posibilidad de comunicarse con el denunciante anónimo luego de haber recibido la denuncia.",
        "thumbnailFileId": 2,
        "thumbnailFile": {
          "id": 2,
          "name": "file1",
          "fileLength": 1,
          "mimeType": "image/png",
            "url": "../../../assets/images/demo-content/Lideres a nivel mundial (2).png"
        },
        "mediaFileId": 1,
        "mediaFile": {
          "id": 3,
          "name": "file1",
          "fileLength": 1,
          "mimeType": "image/png",
            "url": "../../../assets/images/demo-content/Lideres a nivel mundial (2).png"
        },
        "orderPosition": 2,
        "active": true
    }
  ];
  contents;
  // contents=this.mockData;
  // contents: PageContent[] = [
  //   {
  //     "contentTypeId": 1,
  //     "header": "",
  //     "title": "Primero Usted",
  //     "body": "<img class=\"img-resource\"  src=\"https://gpsstorageuat.blob.core.windows.net/public-container/1.Primero%20Usted.png\"><span>Canal de comunicación independiente, seguro, confidencial y anónimo que garantiza protección a los denunciantes ante cualquier medida que pudiera tomar la organización como consecuencia de la denuncia efectuada.</span>",
  //     "thumbnailFileId": null,
  //     "thumbnailFile": null,
  //     "mediaFileId": null,
  //     "mediaFile": null,
  //     "orderPosition": 1,
  //     "active": true,
  //     "tenantId": null
  //   }
  // ];

  constructor(
    private formBuilder: FormBuilder,
    public tenantByNameService: TenantByNameSuggestService,
    private datasourceService: DatasourceService,
    private _fuseConfigService: FuseConfigService,
    private _fuseNavigationService: FuseNavigationService,
    private tenantSelectorService: TenantSelectorService,
    private router: Router,
    private mainPageService: MainPageService,
  ) {
    this.tenants$ = this.datasourceService.getTenantList();
    // this._fuseNavigationService.setCurrentNavigation('tenantSelector');
    this.tenantSelectorService.selectTenant(null);

    this.tenantSelector = new FormControl('');

    // this._fuseConfigService.config = {
    //   layout: {
    //     navbar: {
    //       hidden: true
    //     },
    //     toolbar: {
    //       hidden: true
    //     },
    //     footer: {
    //       hidden: true
    //     },
    //     sidepanel: {
    //       hidden: true
    //     }
    //   }
    // };
    
  }

  ngOnInit() {
    this.tenantSelector.valueChanges.subscribe(tenantId => {
      this.router.navigate(['/portal/' + tenantId]);
    });
    this.tenantForm = this.formBuilder.group({
      tenantName: [null, Validators.required]
    });
    this.mainPageService.getContentsLanding().subscribe(
      res => {
        this.contents = res;
      },
      err => {
        console.log(err);
      }
    );
  }

  updateTenants(item: Tenantstem) {
    this.currentTenantsItem = item;
    this.tenantForm.markAsPristine();
    this.router.navigate(['/portal/' + item.id]);
    this.checkTenanId(item.id);
  }

  checkTenanId(tenantId):void{
    if(!tenantId) return
    const tenantIdStorage = MVLocalStorageService.getItem('tenantId')
    if(!tenantIdStorage){
      MVLocalStorageService.setItem('tenantId',tenantId)
    }else{
      if(tenantIdStorage != tenantId){
          if(MVLocalStorageService.getItem('languages')){
            const languages: any[] = JSON.parse(MVLocalStorageService.getItem('languages'))
            languages.forEach(element => {
              if(MVLocalStorageService.getItem(element.id + '.json')){
                MVLocalStorageService.removeItem(element.id + '.json')
              }
          });
          }
          MVLocalStorageService.removeItem('languages')
          MVLocalStorageService.removeItem('selected_lang')
          MVLocalStorageService.setItem('tenantId',tenantId)
      }
  }
  }
}
